import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { IPlatformAlertOptions, PlatformAlertType } from '../types';
import deprecate from 'q2-tecton-common/lib/utility/deprecate';

export default function showAlert(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('sendAlert') && !platformCapabilities.has('sendAlertWithError')) {
        return;
    }

    return function(alertOptions: IPlatformAlertOptions<PlatformAlertType>): void {
        const legacyDangerEnum = 'danger' as PlatformAlertType;
        if (alertOptions.styleType === legacyDangerEnum) {
            deprecate(
                'calling showAlert with styleType = "danger" is deprecated, please use "error" instead.',
                {
                    until: '1.0.0',
                    package: 'q2-tecton-sdk'
                }
            );
        }

        if (alertOptions.msg !== undefined) {
            deprecate(
                'calling showAlert with msg property is deprecated, please use "message" instead.',
                {
                    until: '1.0.0',
                    package: 'q2-tecton-sdk'
                }
            );
        }

        if (
            !platformCapabilities.has('sendAlertWithError') &&
            alertOptions.styleType === PlatformAlertType.Error
        ) {
            alertOptions.styleType = legacyDangerEnum;
        }

        if (!platformCapabilities.has('sendAlertWithError') && alertOptions.message !== undefined) {
            alertOptions.msg = alertOptions.message;
        }
        sendMessage(`sendAlert`, Maybe.just(alertOptions).map(JSON.stringify));
    };
}
